module.exports = "<div class=\"modal-header\">\n    <div class=\"nav-item-text\">\n        <b>Delete Tag</b>\n    </div>\n</div>\n<div class=\"modal-body text-center\">\n    <h4>Deleting can't be undone.</h4>\n    <span class=\"btn\" ng-click=\"$dismiss()\">Cancel</span>\n    <span class=\"btn btn-red\" ng-click=\"$close()\">Delete</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/modals/tags/confirm-delete.html
// module id = 874
// module chunks = 3